import { WeaponType } from './dataFormat';
export const gauss = {
    fullName: 'Guardian Gauss Cannon',
    internalName: 'gausscannon',
    options: [
        {
            mount: WeaponType.FIXED,
            weaponSize: 1,
            clipSize: 80,
            rof: 0.487804878,
            reloadTime: 4.00,
            distroDraw: 3.8,
            axDamage: 20.00,
            sustainedAxDps: 9.52,
            armourPierce: 140.00,
            falloffRange: 1500.00,
            maxRange: 3000.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00 // set during runtime
        },
        {
            mount: WeaponType.FIXED,
            weaponSize: 2,
            clipSize: 80,
            rof: 0.487804878,
            reloadTime: 4.00,
            distroDraw: 7.2,
            axDamage: 35.00,
            sustainedAxDps: 16.67,
            armourPierce: 140.00,
            falloffRange: 1500.00,
            maxRange: 3000.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        }
    ]
};
const plasma = {
    fullName: 'Guardian Plasma Charger',
    internalName: 'plasmalauncher',
    options: [
        {
            mount: WeaponType.FIXED,
            weaponSize: 1,
            clipSize: 15,
            rof: 0.5555555556,
            reloadTime: 3.00,
            distroDraw: 0.68,
            axDamage: 25.50,
            sustainedAxDps: 11.59,
            armourPierce: 65.00,
            falloffRange: 1000.00,
            maxRange: 3000.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.FIXED,
            weaponSize: 2,
            clipSize: 15,
            rof: 0.5555555556,
            reloadTime: 3.00,
            distroDraw: 1.25,
            axDamage: 42.50,
            sustainedAxDps: 21.25,
            armourPierce: 80.00,
            falloffRange: 1000.00,
            maxRange: 3000.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.FIXED,
            weaponSize: 3,
            clipSize: 15,
            rof: 0.5555555556,
            reloadTime: 3.00,
            distroDraw: 1.25,
            axDamage: 59.50,
            sustainedAxDps: 29.75,
            armourPierce: 95.00,
            falloffRange: 1000.00,
            maxRange: 3000.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.TURRET,
            weaponSize: 1,
            clipSize: 15,
            rof: 0.5555555556,
            reloadTime: 3.00,
            distroDraw: 0.80,
            axDamage: 17.00,
            sustainedAxDps: 8.5,
            armourPierce: 65.00,
            falloffRange: 1000.00,
            maxRange: 3000.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.TURRET,
            weaponSize: 2,
            clipSize: 15,
            rof: 0.5555555556,
            reloadTime: 3.00,
            distroDraw: 1.4,
            axDamage: 34.00,
            sustainedAxDps: 17.00,
            armourPierce: 80.00,
            falloffRange: 1000.00,
            maxRange: 3000.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.TURRET,
            weaponSize: 3,
            clipSize: 15,
            rof: 0.5555555556,
            reloadTime: 3.00,
            distroDraw: 2.6,
            axDamage: 51.00,
            sustainedAxDps: 25.5,
            armourPierce: 95.00,
            falloffRange: 1000.00,
            maxRange: 3000.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        }
    ]
};
const shard = {
    fullName: 'Guardian Shard Cannon',
    internalName: 'shardcannon',
    options: [
        {
            mount: WeaponType.FIXED,
            weaponSize: 1,
            clipSize: 5,
            rof: 1.667,
            reloadTime: 5.00,
            distroDraw: 0.42,
            axDamage: 21.84,
            sustainedAxDps: 13.65,
            armourPierce: 30.00,
            falloffRange: 1700.00,
            maxRange: 1700.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.FIXED,
            weaponSize: 2,
            clipSize: 5,
            rof: 1.667,
            reloadTime: 5.00,
            distroDraw: 0.65,
            axDamage: 40.62,
            sustainedAxDps: 25.39,
            armourPierce: 45.00,
            falloffRange: 1700.00,
            maxRange: 1700.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.FIXED,
            weaponSize: 3,
            clipSize: 5,
            rof: 1.667,
            reloadTime: 5.00,
            distroDraw: 1.4,
            axDamage: 57.00,
            sustainedAxDps: 35.63,
            armourPierce: 60.00,
            falloffRange: 1700.00,
            maxRange: 1700.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.TURRET,
            weaponSize: 1,
            clipSize: 5,
            rof: 1.667,
            reloadTime: 5.00,
            distroDraw: 0.36,
            axDamage: 12.12,
            sustainedAxDps: 7.58,
            armourPierce: 30.00,
            falloffRange: 1700.00,
            maxRange: 1700.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.TURRET,
            weaponSize: 2,
            clipSize: 5,
            rof: 1.667,
            reloadTime: 5.00,
            distroDraw: 0.57,
            axDamage: 26.04,
            sustainedAxDps: 16.28,
            armourPierce: 45.00,
            falloffRange: 1700.00,
            maxRange: 1700.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.TURRET,
            weaponSize: 3,
            clipSize: 5,
            rof: 1.667,
            reloadTime: 5.00,
            distroDraw: 1.2,
            axDamage: 37.20,
            sustainedAxDps: 23.25,
            armourPierce: 60.00,
            falloffRange: 1700.00,
            maxRange: 1700.00,
            stdAmmoPercent: 1.15,
            premAmmoPercent: 1.30,
            nDps: 0.00,
            falloffFactor: 1.00
        },
    ]
};
const axmc = {
    fullName: 'AX Multi-cannon',
    internalName: 'atmulticannon',
    options: [
        {
            mount: WeaponType.FIXED,
            weaponSize: 2,
            clipSize: 100,
            rof: 7.14,
            reloadTime: 4.00,
            distroDraw: 0.11,
            axDamage: 2.19,
            sustainedAxDps: 12.17,
            armourPierce: 17.00,
            falloffRange: 2000.00,
            maxRange: 4000.00,
            stdAmmoPercent: 1.05,
            premAmmoPercent: 1.10,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.FIXED,
            weaponSize: 3,
            clipSize: 100,
            rof: 5.88,
            reloadTime: 4.00,
            distroDraw: 0.18,
            axDamage: 3.92,
            sustainedAxDps: 18.69,
            armourPierce: 33.00,
            falloffRange: 2000.00,
            maxRange: 4000.00,
            stdAmmoPercent: 1.05,
            premAmmoPercent: 1.10,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.TURRET,
            weaponSize: 2,
            clipSize: 90,
            rof: 6.25,
            reloadTime: 4.00,
            distroDraw: 0.06,
            axDamage: 1.17,
            sustainedAxDps: 5.72,
            armourPierce: 17.00,
            falloffRange: 2000.00,
            maxRange: 4000.00,
            stdAmmoPercent: 1.05,
            premAmmoPercent: 1.10,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.TURRET,
            weaponSize: 3,
            clipSize: 90,
            rof: 6.25,
            reloadTime: 4.00,
            distroDraw: 0.06,
            axDamage: 2.12,
            sustainedAxDps: 10.39,
            armourPierce: 33.00,
            falloffRange: 2000.00,
            maxRange: 4000.00,
            stdAmmoPercent: 1.05,
            premAmmoPercent: 1.10,
            nDps: 0.00,
            falloffFactor: 1.00
        }
    ]
};
const axmr = {
    fullName: 'AX Missile Rack',
    internalName: 'atdumbfiremissile',
    options: [
        {
            mount: WeaponType.FIXED,
            weaponSize: 2,
            clipSize: 8,
            rof: 0.50,
            reloadTime: 5.00,
            distroDraw: 0.14,
            axDamage: 37.00,
            sustainedAxDps: 14.10,
            armourPierce: 60.00,
            falloffRange: 4000.00,
            maxRange: 4000.00,
            stdAmmoPercent: 1.05,
            premAmmoPercent: 1.10,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.FIXED,
            weaponSize: 3,
            clipSize: 12,
            rof: 0.50,
            reloadTime: 5.00,
            distroDraw: 0.24,
            axDamage: 37.00,
            sustainedAxDps: 15.31,
            armourPierce: 60.00,
            falloffRange: 4000.00,
            maxRange: 4000.00,
            stdAmmoPercent: 1.05,
            premAmmoPercent: 1.10,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.TURRET,
            weaponSize: 2,
            clipSize: 8,
            rof: 0.50,
            reloadTime: 5.00,
            distroDraw: 0.08,
            axDamage: 30.00,
            sustainedAxDps: 11.43,
            armourPierce: 60.00,
            falloffRange: 5000.00,
            maxRange: 5000.00,
            stdAmmoPercent: 1.05,
            premAmmoPercent: 1.10,
            nDps: 0.00,
            falloffFactor: 1.00
        },
        {
            mount: WeaponType.TURRET,
            weaponSize: 3,
            clipSize: 12,
            rof: 0.50,
            reloadTime: 5.00,
            distroDraw: 0.14,
            axDamage: 30.00,
            sustainedAxDps: 12.41,
            armourPierce: 60.00,
            falloffRange: 5000.00,
            maxRange: 5000.00,
            stdAmmoPercent: 1.05,
            premAmmoPercent: 1.10,
            nDps: 0.00,
            falloffFactor: 1.00
        }
    ]
};
export const AX_WEAPONS = [
    gauss, plasma, shard, axmc, axmr
];
